import { sortDirection, SortItem } from '../../app/models/ss-api/responses/member.dashboard.license.response';

export interface ISortable {
    LastSort: SortItem;
    length: any;
}

export class SortBot {

    // ---------------------------------------------------------------------------------------------------------
    // Sort in Ascending Order
    public static SortAsc<T extends ISortable>(toSortArray: T, toSortPropertyName: string, subArraySortItem: string = '' ): T {
        return this.Sort<T>( toSortArray, toSortPropertyName, subArraySortItem, sortDirection.Ascending );
    }


    // ---------------------------------------------------------------------------------------------------------
    // Sort in Descending Order
    public static SortDesc<T extends ISortable>(toSortArray: T, toSortPropertyName: string, subArraySortItem: string = '' ): T {
        return this.Sort<T>( toSortArray, toSortPropertyName, subArraySortItem, sortDirection.Descending );
    }


    // ---------------------------------------------------------------------------------------------------------
    // Sort Automatically by last sort order
    // IF it is the same column as the last sorted column in this array
    // ELSE sort Descending Order
    public static SortAuto<T extends ISortable>(toSortArray: T, toSortPropertyName: string, subArraySortItem: string = '' ): T {
        let direction: sortDirection = sortDirection.Ascending;

        if ( toSortArray.LastSort == undefined )
            toSortArray.LastSort = new SortItem();

        if ( toSortArray.LastSort.SortCol == toSortPropertyName + subArraySortItem ) {
            // direction = toSortArray.LastSort.SortDirection == sortDirection.Descending ? sortDirection.Ascending : sortDirection.Descending;
            direction = toSortArray.LastSort.SortDirection == sortDirection.Ascending ? sortDirection.Descending : sortDirection.Ascending;
        }else {

        }

        return this.Sort<T>( toSortArray, toSortPropertyName, subArraySortItem, direction );
    }


    // ---------------------------------------------------------------------------------------------------------
    // Base sort functionality
    public static Sort<T extends ISortable>(toSortArray: T, toSortPropertyName: string, subArraySortItem: string = '', direction: sortDirection = sortDirection.NotSpecified ): T {

        let predicateResult = direction == sortDirection.Ascending ? 1 : -1;

        if ( toSortArray.LastSort == undefined )
            toSortArray.LastSort = new SortItem();

        toSortArray.LastSort.SortDirection = direction;
        toSortArray.LastSort.SortCol = toSortPropertyName + subArraySortItem;


        if (toSortArray[0] == undefined) {
            return;
        }

        let checkIndex: number = 0;

        for ( let i: number = 0; i < toSortArray.length; i++ ) {
            let checkProp = this.GetProp(toSortArray[i], toSortPropertyName, subArraySortItem);
            if ( checkProp != '' ) {
                checkIndex = i;
                break;
            }
        }

        // if (toSortArray[0][toSortPropertyName] instanceof Date)
        if ( this.GetProp(toSortArray[checkIndex], toSortPropertyName, subArraySortItem) instanceof Date) {
            (<any>toSortArray).sort((a, b) => {

                return this.SortByDate( a, b, toSortPropertyName, subArraySortItem, predicateResult );

            });
        } else if (typeof this.GetProp(toSortArray[checkIndex], toSortPropertyName, subArraySortItem) == 'number') {
            // else if (toSortArray[0][toSortPropertyName] instanceof Number)
            (<any>toSortArray).sort((a, b) => {

                return this.SortByNumber( a, b, toSortPropertyName, subArraySortItem, predicateResult );

            });
        } else {
            (<any>toSortArray).sort((a, b) => {

                return this.SortByString( a, b, toSortPropertyName, subArraySortItem, predicateResult );

            });
        }

        return toSortArray;
    }


    // ---------------------------------------------------------------------------------------------------------
    // Sort objects by date
    private static SortByDate( a: Date, b: Date, toSortPropertyName: string, subArraySortItem: string, predicateResult: number ): number {

        let sortPropA = this.GetProp( a, toSortPropertyName, subArraySortItem);
        let sortPropB = this.GetProp( b, toSortPropertyName, subArraySortItem);

        let sortA: Date = sortPropA == null || sortPropA == undefined ? new Date(0, 0, 0) : sortPropA;
        let sortB: Date = sortPropB == null || sortPropB == undefined ? new Date(0, 0, 0) : sortPropB;

        if ( sortA < sortB ) return predicateResult;
        else if ( sortA > sortB ) return predicateResult * -1;
        else return 0;

    }


    // ---------------------------------------------------------------------------------------------------------
    // Sort objects by number
    private static SortByNumber( a: any, b: any, toSortPropertyName: string, subArraySortItem: string, predicateResult: number ): number {

        let sortPropA = this.GetProp( a, toSortPropertyName, subArraySortItem);
        let sortPropB = this.GetProp( b, toSortPropertyName, subArraySortItem);

        let sortA: number = sortPropA == null || sortPropA == undefined ? 0 : sortPropA;
        let sortB: number = sortPropB == null || sortPropB == undefined ? 0 : sortPropB;

        if ( sortA < sortB ) return predicateResult;
        else if ( sortA > sortB ) return predicateResult * -1;
        else return 0;

    }


    // ---------------------------------------------------------------------------------------------------------
    // Sort objects by string - will convert non-string
    private static SortByString( a: any, b: any, toSortPropertyName: string, subArraySortItem: string, predicateResult: number ): number {

        let sortPropA = this.GetProp( a, toSortPropertyName, subArraySortItem);
        let sortPropB = this.GetProp( b, toSortPropertyName, subArraySortItem);

        let sortA: string = sortPropA == null || sortPropA == undefined ? '' : sortPropA.toString();
        let sortB: string = sortPropB == null || sortPropB == undefined ? '' : sortPropB.toString();

        return sortA.localeCompare(sortB) * predicateResult;

    }


    // --------------------------------------------------------------------------------------------------------------
    // Get Properties for sorting, determine if we need to get a property from a sub array item as well - cool beans!
    private static GetProp( a: any, toSortPropertyName: string, subArraySortItem: string ): any {
        let sortProp = a[toSortPropertyName];

        if ( sortProp == undefined ) {
            return '';
        }

        if ( subArraySortItem != '' ) {
            if ( sortProp == undefined )
                return '';

            if (sortProp instanceof Array) {
                sortProp = sortProp[0][subArraySortItem];
            } else {
                sortProp = sortProp[subArraySortItem];
            }

        }

        return sortProp;

    }


}
